import { UnwrapPromise } from "@prisma/client";
import { FiExternalLink } from "react-icons/fi";
import { Link, LoaderFunction, useLoaderData } from "remix";
import { BreadcrumbLink } from "~/components/Breadcrumbs";
import { Logo } from "~/components/Logo";
import { db } from "~/utils/db.server";
import { getCurrentFestival } from "~/utils/festival.server";

async function loadFestivals() {
  return db.festival.findMany({
    where: {
      publishedAt: {
        not: null,
        lte: new Date(),
      },
    },
    orderBy: [{ publishedAt: "desc" }, { name: "desc" }],
  });
}

export type LoaderData = {
  festivals: UnwrapPromise<ReturnType<typeof loadFestivals>>;
  currentFestivalId?: string;
};

export const loader: LoaderFunction = async ({}) => {
  const festivals = await loadFestivals();
  const currentFestivalId = (await getCurrentFestival())?.id;

  return { festivals, currentFestivalId };
};

export const handle = {
  breadcrumb: () => <BreadcrumbLink to="/archive">Archiv</BreadcrumbLink>,
};

export default function ArchivePage() {
  const { festivals, currentFestivalId } = useLoaderData<LoaderData>();

  return (
    <div className="main-layout-centered">
      <div className="grid md:grid-cols-2 lg:grid-cols-3 my-8 gap-4">
        {festivals.map((festival) => (
          <div key={festival.id} data-theme={festival.id}>
            <Link
              to={`/${festival.slug}`}
              key={festival.id}
              className="relative block px-4 py-24 rounded-md border-2 bg-primary-50 border-primary-400"
            >
              <Logo className="w-1/2 mx-auto mb-7" />
              <div className="text-center flex items-center justify-center gap-2 text-primary-600 font-bold text-3xl">
                {festival.name}
                {currentFestivalId === festival.id && (
                  <div className="text-lg inline-block p-2 bg-primary-600 text-primary-50">
                    Latest
                  </div>
                )}
              </div>
            </Link>
          </div>
        ))}
      </div>

      <a
        className="px-8 py-8 rounded-md border-2 bg-gray-50 border-gray-400"
        href="http://wwsu2021.wewontshutup.org/"
        target="_blank"
        rel="noopener noreferrer nofollow"
      >
        <div className="text-center flex items-center gap-2 text-gray-600 font-bold text-3xl">
          <FiExternalLink /> Archiv 2021
        </div>
      </a>
    </div>
  );
}
